// extracted by mini-css-extract-plugin
export default {"stack":"S6g5fYTiaGi8KQAjmoxQ","overview":"b0kpuidwttFuHB57A3kK"};